import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { UnionLocations } from '../types';

class CountryList{
  countryList: UnionLocations[] = [];
  getCountryList = async () => {
    this.countryList = await apiConfig.countryService.getByLocation();
  };
  location: UnionLocations | undefined  = undefined;
  isFetchedLocation = false;
  setLocation = (value: UnionLocations) => {
    this.location = value;
  };

  getUserLocation = async () => {
    this.isFetchedLocation = false;
    await apiConfig.countryService.getUserLocation().then(res => {
      this.location = res.country;
      this.isFetchedLocation = true;
    });
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export const CountryListStore = new CountryList();
